import classnames from 'classnames/bind';
import { forwardRef } from 'react';

import styles from './CheckBox.module.scss';

type InputStates = 'default' | 'error' | 'success';
type Ref = HTMLInputElement;

interface ICheckBoxProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name: string;
  value?: any;
  disabled?: boolean;
  state?: InputStates;
}

const cn = classnames.bind(styles);

export const CheckBox = forwardRef<Ref, ICheckBoxProps>(function CheckBox(
  { state = 'default', ...rest },
  ref
) {
  const classes = cn('checkbox', {
    'checkbox--error': state === 'error',
    'checkbox--success': state === 'success',
  });
  
  return (
    <div className={`${classes} ${styles.containerOptionCheckbox}`}>
      <input type="checkbox" {...rest} ref={ref} />
    </div>
  );
});